// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/system';
// MUI icons
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

// load navigation contents from JSON file
import footerContentItemsProduction from '@config/data/footerContentItems.json';
import footerContentItemsStaging from '@config/data/footerContentItems.staging.json';
import footerContentItemsDevelopment from '@config/data/footerContentItems.development.json';

// Section for import custom components --------------------------------------------------------------------------------
import CommonUtility from '@utils/Common';
import { AppConfigContext } from '@providers/AppConfigProvider';

const StyledAccordionSummary = styled(AccordionSummary)({
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 0,
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
  '& .MuiAccordionSummary-expandIcon': {
    order: -1,
  },
  '& .Mui-expanded': {
    margin: '0 !important',
  },
});

export default function MenuContent(): React.JSX.Element {
  const { appEnv } = useContext(AppConfigContext);

  const footerContentItems = CommonUtility.getEnvBasedValue(
    {
      production: footerContentItemsProduction,
      staging: footerContentItemsStaging,
      development: footerContentItemsDevelopment,
    },
    appEnv,
  );
  return (
    <Box className="border-rf-border border-y-[1px]">
      {footerContentItems.map((item) =>
        item.children && item.children.length > 0 ? ( // アコーディオンの子要素がない場合、要素の開閉を行わないように制御
          <Accordion
            key={item.key}
            sx={{
              backgroundColor: 'transparent',
              color: '#D5D5D5',
              borderRadius: 0,
              '&.Mui-expanded': {
                margin: 0,
                '&::before': {
                  opacity: 1,
                },
              },
            }}
            elevation={0}
          >
            <StyledAccordionSummary
              className="min-h-fit"
              expandIcon={
                <KeyboardArrowDownRoundedIcon
                  sx={{
                    color: '#191919',
                  }}
                />
              }
            >
              <Typography
                className="py-4 leading-6 font-bold rfHoverTex"
                sx={{
                  flexGrow: 1,
                }}
              >
                <a href={item.href} rel="noopener noreferrer" className="hover:no-underline text-rf-black text-base">
                  {item.label}
                </a>
              </Typography>
            </StyledAccordionSummary>
            <AccordionDetails className="flex flex-col pl-4 py-0">
              {item.children.map((child) => (
                <div key={child.key} className="pb-4 last:pb-5 text-sm rf-hover-text">
                  <Typography>
                    <a href={child.href} rel="noopener noreferrer" className="hover:no-underline text-rf-black text-sm">
                      {child.label}
                    </a>
                  </Typography>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        ) : (
          <Box className="py-4 border-rf-border border-t-[1px]" key={item.key}>
            <Typography className="font-bold rf-hover-text" style={{ flexGrow: 1 }}>
              <a href={item.href} rel="noopener noreferrer" className="hover:no-underline text-rf-black text-base">
                {item.label}
              </a>
            </Typography>
          </Box>
        ),
      )}
    </Box>
  );
}
